/* import __COLOCATED_TEMPLATE__ from './theme-option-card.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { assetUrl } from '@intercom/pulse/helpers/asset-url';

interface ThemeOptionCardSignature {
  Args: {
    title: string;
    value: string;
    selectedValue: string;
    radioName: string;
    onSelect: (value: string) => void;
    onAnalyticsTrack?: (value: string) => void;
    previewType: 'light' | 'dark' | 'system';
  };
}

export default class ThemeOptionCard extends Component<ThemeOptionCardSignature> {
  get isSelected() {
    return this.args.selectedValue === this.args.value;
  }

  get radioId() {
    return `theme-option-${this.args.value}`;
  }

  get previewImage() {
    switch (this.args.previewType) {
      case 'light':
        return assetUrl('/assets/images/messenger-settings/light-theme.png');
      case 'dark':
        return assetUrl('/assets/images/messenger-settings/dark-theme.png');
      case 'system':
      default:
        return assetUrl('/assets/images/messenger-settings/system-theme.png');
    }
  }

  @action
  handleClick() {
    this.args.onSelect(this.args.value);
    if (this.args.onAnalyticsTrack) {
      this.args.onAnalyticsTrack(this.args.value);
    }
  }

  @action
  handleRadioChange() {
    this.args.onSelect(this.args.value);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    ThemeOptionCard: typeof ThemeOptionCard;
    'theme-option-card': typeof ThemeOptionCard;
  }
}
